module.exports = __webpack_public_path__ + "static/template_options_1_day_with_timeslot_columns-fe3e228afd4f210d95dd4ccbcd3dc7b9.png";